import BillLading from '@/components/BillLading/BillLading';
export default {
    name: "collectWriteBillFinalAudit",
	conditionData:'',
	created: function () {
      this.init();
	},
	components:{
      BillLading
	},
    data() {
        return {
			edit: true,
			showBillLading : true,
			showPdf :false,
            billLadingData: {
                shipper: "shipper input text",
                consignee: "consignee input text",
                notifyParty: "notifyPart input text", ///
                placeOfreceipt: "placeOfreceipt input text",
                vessel: "vessel input text",
                portOfLoading: "portOfLoading input text",
                portOfTransshipment: "portOfTransshipment input text",
                PortOfDischarge: "portOfDischarge input text", ///
                PlaceOfDelivery: "placeOfDelivery input text", //
                freightCharges: "freightAndCharges input text", //
                NoOfOriginal: "noOfOriginal input text", //
                declared: "declared input text",
                voyageNo: "voyageNo input text",
                preCarriageBy: "carriageBy input text", //
                planceAndDate: "planceAndDate input text",
                forwardingAgent: "forAgent input text", //
                signedBy: "",
                typeOfMovement: "typeOfMovement input text",
                blNo: "billNo input text", //
				goodList:[],
				isAddtionalImageDisplay: ''
              },
			writeBillFinalAuditForm: {
				signer:'',
				issuingParty_label:'',
				billingFee:'',
				issuingTime:'',
				portOfDischarge:'',
				payment:'',
				billFormatter: this.$t('c_addWriteBill.billFormatter'),
				billType: this.$t('c_addWriteBill.billType'),
				billAdditionalDescription:'',
				billAdditionalDescriptionOfSend:'',
				stdContainerNumber:'',
				sendAuditResult:'',
				sendAuditOpinion:'',
				recFirstAuditResult:'',
				recFirstAuditOpinion:'',
				recFinalAuditResult:'',
				recFinalAuditOpinion:'',
				signAuditResult:'',
				signAuditOpinion:''
			},
			// 公司下拉列表
			companyList: [],
			imageType: 1,
			// 出单费下拉列表
			costList:[]
        }
	},
	computed: {
		rules() {
			return {
				recFinalAuditResult: [
					{ required: true, //是否必填
					message: this.$t('c_writeBillFinaltAduit.validateMassage'), //提示信息
					trigger: 'blur'  //何事件触发
					}
				]	,
			}
		},
		singCompanyList(){
			if(this.writeBillFinalAuditForm.issuingParty_label && this.writeBillFinalAuditForm.signer){
				if(this.writeBillFinalAuditForm.issuingParty_label === this.writeBillFinalAuditForm.signer){
					const id = this.writeBillFinalAuditForm.issuingParty_label;
					return [{id:id, companyName: this.getCompanyName(id)}]
				}else{
					const isId = this.writeBillFinalAuditForm.issuingParty_label;
					const sid = this.writeBillFinalAuditForm.signer;
					return [{id:isId, companyName: this.getCompanyName(isId)},
					{id:sid, companyName: this.getCompanyName(sid)}]
				}
			}
			return [];
		},
		billingFeeCompanyList(){
			let arr = [{
				id: this.conditionData.row.receiveCompanyId,
				companyName: this.conditionData.row.receiveCompanyName
			}];
			if(this.writeBillFinalAuditForm.issuingParty_label && this.writeBillFinalAuditForm.signer){
				if(this.writeBillFinalAuditForm.issuingParty_label === this.writeBillFinalAuditForm.signer){
					const id = this.writeBillFinalAuditForm.issuingParty_label;
					arr.push(...[{id:id, companyName: this.getCompanyName(id)}]);
				}else{
					const isId = this.writeBillFinalAuditForm.issuingParty_label;
					const sid = this.writeBillFinalAuditForm.signer;
					arr.push(...[{id:isId, companyName: this.getCompanyName(isId)},
						{id:sid, companyName: this.getCompanyName(sid)}]);
				}
			}
			return arr;
		},
	},
    methods: {
        init(){
			this.conditionData = this.$routerUtil.getParam();
			if(this.conditionData.row){
				this.billLadingData.shipper = this.conditionData.row.shipper;
				this.billLadingData.consignee = this.conditionData.row.consignee;
				this.billLadingData.notifyParty = this.conditionData.row.notifyParty;
				this.billLadingData.placeOfreceipt = this.conditionData.row.placeOfreceipt;
				this.billLadingData.vessel = this.conditionData.row.vessel;
				this.billLadingData.portOfLoading = this.conditionData.row.portOfLoading;
				this.billLadingData.portOfTransshipment = this.conditionData.row.portOfTransshipment;
				this.billLadingData.PortOfDischarge = this.conditionData.row.PortOfDischarge;
				this.billLadingData.PlaceOfDelivery = this.conditionData.row.PlaceOfDelivery;
				this.billLadingData.freightCharges = this.conditionData.row.freightCharges;
				this.billLadingData.NoOfOriginal = this.conditionData.row.NoOfOriginal;
				this.billLadingData.declared = this.conditionData.row.declared;
				this.billLadingData.voyageNo = this.conditionData.row.voyageNo;
				this.billLadingData.preCarriageBy = this.conditionData.row.preCarriageBy;
				this.billLadingData.planceAndDate = this.conditionData.row.planceAndDate;
				this.billLadingData.forwardingAgent = this.conditionData.row.forwardingAgent;
				this.billLadingData.signedBy = this.conditionData.row.signedBy;
				this.billLadingData.typeOfMovement = this.conditionData.row.typeOfMovement;
				this.billLadingData.blNo = this.conditionData.row.blNo;
				this.billLadingData.finalDestination = this.conditionData.row.finalDestination;
				this.billLadingData.totalNumber = this.conditionData.row.totalNumber;
				this.billLadingData.goodList = this.conditionData.row.billGoods;
				this.billLadingData.isAddtionalImageDisplay = this.conditionData.row.isAddtionalImageDisplay;
				this.writeBillFinalAuditForm.signer = this.conditionData.row.signatureCompanyId;
				this.writeBillFinalAuditForm.issuingParty_label = this.conditionData.row.sendCompanyId;
				this.writeBillFinalAuditForm.billingFee = this.conditionData.row.sendBillFeeCompanyId;
				this.writeBillFinalAuditForm.issuingTime = this.conditionData.row.sendBillDate;
				this.writeBillFinalAuditForm.portOfDischarge = this.conditionData.row.costId;
				this.writeBillFinalAuditForm.payment = parseInt(this.conditionData.row.payType);
				this.writeBillFinalAuditForm.billAdditionalDescription = this.conditionData.row.billAdditionalDescription;
				this.writeBillFinalAuditForm.billAdditionalDescriptionOfSend = this.conditionData.row.billAdditionalDescriptionOfSend;
				this.writeBillFinalAuditForm.stdContainerNumber = this.conditionData.row.stdContainerNumber;
				this.writeBillFinalAuditForm.sendAuditResult= this.conditionData.row.scfAuditResult;
				this.writeBillFinalAuditForm.sendAuditOpinion= this.conditionData.row.scfAuditOpinion;
				this.writeBillFinalAuditForm.recFirstAuditResult= this.conditionData.row.rcfAuditResult;
				this.writeBillFinalAuditForm.recFirstAuditOpinion= this.conditionData.row.rcfAuditOpinion;
				this.writeBillFinalAuditForm.recFinalAuditResult= this.conditionData.row.rcsAuditResult;
				this.writeBillFinalAuditForm.recFinalAuditOpinion= this.conditionData.row.rcsAuditOpinion;
				this.writeBillFinalAuditForm.signAuditResult= this.conditionData.row.signatureAuditResult;
				this.writeBillFinalAuditForm.signAuditOpinion= this.conditionData.row.signatureAuditOpinion;
				// 如果不是wiffa
				if(this.conditionData.row.billImageName !== 'bill_image_wiffa.png'){
					this.imageType = 2;
				}
			}
			// 查询当前提单中的收单公司建立合作关系的出单公司下拉列表
			const selectSendCompanyParam = {};
			selectSendCompanyParam.receiveCompanyId = this.conditionData.row.receiveCompanyId;
			this.$axios({
				method: "get",
				url: "api/customerCompay/selecCompayCustomer", 
				params: selectSendCompanyParam
				}).then(res => {
					this.companyList = res.data.resultData;
				}).catch(error => {
					console.log(error);
					this.$message({
						message: this.$t('common.message.operateFail'),
						type: 'error',
						center: true
					});
				});
			// 查询出单费集合下拉
			const param = {};
			// param.isDefault = 0;
			this.$axios.get('/api/cost/selectCostIsDefault',{params:param}).then(response => {
				this.costList = response.data.resultData;
			}).catch(e => {
				console.log(e);
				this.$message({
					message: this.$t('common.message.operateFail'),
					type: 'error',
					center: true
				});
			});
		},
		submitForm(writeBillFinalAuditForm){
			this.$refs[writeBillFinalAuditForm].validate(valid => {
				if (valid) {
					var param = new Object();
					param.rcsAuditResult = this.writeBillFinalAuditForm.recFinalAuditResult;
					param.rcsAuditOpinion = this.writeBillFinalAuditForm.recFinalAuditOpinion;
					param.id = this.conditionData.row.id
					param.version = this.conditionData.row.version;
					if(this.writeBillFinalAuditForm.recFinalAuditResult===1){
						param.rcAuditStatus = '3';
					}
					if(this.writeBillFinalAuditForm.recFinalAuditResult===0){
						param.rcAuditStatus = '4';
					}
					
					this.$axios({
						method: "put",
						url: "api/receipts/recordVerifyUpdate", // 接口地址
						data:param
						}).then(res => {
							console.log();
							if(res.data.status==='1'){
								let message = '';
								// 审核通过
								if(this.writeBillFinalAuditForm.recFinalAuditResult===1){
									message = this.$t('c_addWriteBill.toBeSendSignature')
								}
								// 审核拒绝
								if(this.writeBillFinalAuditForm.recFinalAuditResult===0){
									message = this.$t('common.refusedSuccess')
								}
								this.$message({
									// message: this.$t('c_addWriteBill.successMassage'),
									// 2021-01-29 修改提示消息 等待出单方签章操作(2020.2.22 修改拒绝的提示消息)
									message: message,
									type: 'success',
									center: true
								});
								this.$routerUtil.setParam(this.conditionData.searchForm);
								this.$router.push('write-billfinal-audit-manage');
							}
						}).catch(error => {
							console.log(error);
							this.$message({
								message: 'This is an error message',
								type: 'error',
								center: true
							});
						}); 
				} else {
					console.log('error submit!!');
					return false
				}
			});
		},
		doCancel(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('write-billfinal-audit-manage');
		},
		getCompanyName(id){
			let companyName = '';
			this.companyList.forEach(item => {
				if(id === item.id){
					companyName = item.companyName;
				}
			});
			return companyName;
		}
    }
}
